
<template>
  <router-view/>
</template>

<script lang="ts" setup>
import "intro.js/introjs.css";
</script>